// Angular expects the path relative to `basePath`, while svelte-routing expects
// the full path. Match on a path boundary to avoid `/12` matching `/123`.
export const deriveMountedPath = (pathname, search, basePath) => {
  const matches = pathname === basePath || pathname.startsWith(`${basePath}/`);
  if (!matches) return null;

  const query = search || "";
  return {
    full: pathname + query,
    relative: (pathname.slice(basePath.length) || "/") + query,
  };
};
